SourceHireLayoutContainer.$inject = [];

function SourceHireLayoutContainer() {
}

angular
    .module("harriApp")
    .component("sourceHireLayoutContainer", {
        controller: SourceHireLayoutContainer,
        bindings: {},
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/source-hire-layout/containers/source-hire-layout.container.html'
    });